function o(o){var n=typeof o;return"string"==n||"number"==n||"symbol"==n||"boolean"==n?"__proto__"!==o:null===o}export{o as default};
//# sourceMappingURL=_isKeyable.js.map
